import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import clsx from 'clsx';

import useLoadPeriodos from '../../hooks/useLoadPeriodos';

import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import MenuIcon from '@material-ui/icons/Menu';

import useStyles from './Style';

import LegacyMode from '../LegacyMode/LegacyMode';
import TesterMode from '../TesterMode/TesterMode';

import { getUsername, getFullName } from '../../security/keycloak';
import AuthorizedFunction from '../../security/AuthorizedFunction';
import { 
    __ESCOLA, 
    __COORDENADOR, 
    __APOIO_SECRETARIAL 
} from '../../security/RoleConfiguration';

import { getFullEdition } from '../../helper/ContextHelper';

import logo from '../../assets/img/logo-horizontal-fundo-azul.png';

export function Navbar (props) {
    const classes = useStyles();
    let history = useHistory();

    const contexts = useLoadPeriodos();

    const handleCloseAppClick = () => {
        props.handleLogout({ redirectUri: process.env.REACT_APP_PUBLIC_URL });
        history.push("/");
    }

    const handleHomeClick = () => {
        history.push("/");
    }

    return (
        <AppBar
            position="fixed"
            className={clsx(classes.appBar, 'no-print', {
                [classes.appBarShift]: props.open,
            })}
        >
            <LegacyMode />
            <TesterMode />
            <Toolbar>
                <Grid 
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                >
                    <Grid 
                        item
                        container 
                        direction="row" 
                        xs={3} 
                        lg={3} 
                        justify="flex-start"
                    >
                        { !props.open &&
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={props.click}
                                edge="start"
                                className={clsx(classes.menuButton, props.open && classes.hide)}
                            >
                                <MenuIcon />
                            </IconButton>
                        }
                        <Link to={"/"} >
                            <img src={logo} className={classes.logoNav} alt={props.nameApp}/>
                        </Link>
                    </Grid>
                    <Grid 
                        item
                        container 
                        direction="row" 
                        xs={3} 
                        lg={3} 
                        justify="flex-start"
                    >
                        <Typography variant="h6" noWrap>
                            {contexts && getFullEdition(contexts)}
                        </Typography>
                    </Grid>
                    <Grid 
                        item
                        container 
                        direction="row" 
                        xs={5} 
                        lg={5} 
                        justify="flex-end"
                    >
                        <Typography variant="h6" noWrap>
                            { AuthorizedFunction([ __ESCOLA, __COORDENADOR, __APOIO_SECRETARIAL ]) ? 
                                <> {getUsername()} - {getFullName()} </> 
                            : 
                                <> {getFullName()} </> 
                            }
                        </Typography>
                    </Grid>
                    <Grid 
                        item 
                        container
                        direction="row" 
                        xs={1} 
                        lg={1} 
                        justify="flex-end"  
                    >
                        <Tooltip title="Página Inicial">
                            <IconButton
                                color="inherit"
                                aria-label="Página Inicial"
                                edge="start"
                                onClick={handleHomeClick}
                            >
                                <HomeIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Sair">
                            <IconButton
                                color="inherit"
                                aria-label="Sair"
                                edge="end"
                                onClick={handleCloseAppClick}
                            >
                                <ExitToAppIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    );
}

export default Navbar;